import { ProductEligibility } from 'data/Eligibility/types'
import { Eligibile } from 'data/Payments/Elegible/types'
import fetchApi from 'utils/fetchApi'
import { getApiUrl } from 'utils/urlBuilder'

export const fetchPaymentEligibility = (currency: string) =>
  fetchApi<Eligibile[]>({
    auth: true,
    method: 'GET',
    queryParams: { currency },
    url: getApiUrl('nabu-gateway/eligible/payment-methods')
  })

export const fetchProductEligibility = () =>
  fetchApi<ProductEligibility>({
    auth: true,
    method: 'GET',
    url: getApiUrl('nabu-gateway/products?product=MERCURY')
  })
